import { PublicRoute } from "@/app/routes/public";
import { ProtectedRoute } from "@/app/routes/protected";
import { PATHS } from "@/lib/router";
import {
  AuthPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  ChangePasswordPage,
} from "./pages";
import { SustainabilityPage } from "./components/SustainabilityPage";

export const authRoutes = [
  {
    path: PATHS.ROOT,
    element: (
      <PublicRoute>
        <SustainabilityPage />
      </PublicRoute>
    ),
  },
  {
    path: PATHS.LOGIN,
    element: (
      <PublicRoute>
        <AuthPage />
      </PublicRoute>
    ),
  },
  {
    path: PATHS.REGISTER,
    element: (
      <PublicRoute>
        <AuthPage />
      </PublicRoute>
    ),
  },
  {
    path: PATHS.FORGOT_PASSWORD,
    element: (
      <PublicRoute>
        <ForgotPasswordPage />
      </PublicRoute>
    ),
  },
  {
    path: PATHS.RESET_PASSWORD,
    element: (
      <PublicRoute>
        <ResetPasswordPage />
      </PublicRoute>
    ),
  },
  {
    path: PATHS.CHANGE_PASSWORD,
    element: (
      <ProtectedRoute>
        <ChangePasswordPage />
      </ProtectedRoute>
    ),
  },
];
